import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AdminSidebar from './AdminSidebar';
import AdminNavbar from './AdminNavbar';
import AIChatDrawer from './AIChatDrawer';

function AdminLayout() {
  const { hasSectionAccess } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [panelWidth, setPanelWidth] = useState(420);
  const canUseAI = hasSectionAccess('ia', 'view');

  // Detectar se é mobile ou desktop
  useEffect(() => {
    const checkScreen = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      // Desktop: sidebar sempre aberta
      // Mobile: sidebar sempre fechada inicialmente
      setSidebarOpen(!mobile);
    };

    // Verificar tamanho inicial
    checkScreen();

    // Listener para resize
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="admin-layout-modern">
      {/* Sidebar */}
      <AdminSidebar isOpen={sidebarOpen} closeSidebar={closeSidebar} />
      
      {/* Overlay - apenas mobile */}
      {isMobile && sidebarOpen && (
        <div 
          className="sidebar-overlay-modern"
          onClick={closeSidebar}
        ></div>
      )}
      
      {/* Conteúdo principal */}
      <div className="main-content-modern">
        <AdminNavbar toggleSidebar={toggleSidebar} />
        
        <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
          <main className="main-container-modern" style={{
            flex: '1 1 0',
            minWidth: 0,
            transition: 'padding 0.3s ease',
            ...(chatOpen && !isMobile ? { paddingRight: `${panelWidth + 12}px` } : {})
          }}>
            <Outlet />
          </main>
          {canUseAI && (
            <AIChatDrawer open={chatOpen} onToggle={() => setChatOpen(prev => !prev)} panelWidth={panelWidth} onWidthChange={setPanelWidth} />
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
